const commonDefaults = {
  getVideoUrl: (src) => `https://video.wixstatic.com/${src.pathname}`,
  getThumbnailUrl: (src) => {
    if (src.pathname.startsWith("media/")) {
      return `https://static.wixstatic.com/${src.pathname}`;
    }
    return `https://static.wixstatic.com/media/${src.pathname}`;
  }
};
const DEFAULT_CONFIGS = {
  editor: {
    toolbar: {
      hidden: []
    },
    ...commonDefaults
  },
  viewer: {
    ...commonDefaults
  }
};
export {
  DEFAULT_CONFIGS
};
//# sourceMappingURL=defaults.js.map
